// Admin Service - Firebase Firestore Admin Check
import { doc, getDoc } from 'firebase/firestore';
import { db } from './firebase';

export interface AdminUser {
    isAdmin: boolean;
    role: 'superadmin' | 'admin' | 'moderator';
    addedAt?: string;
}

/**
 * Check if a user email exists in the admins collection
 * @param email User's email address
 * @returns Promise<boolean> - true if user is admin
 */
export const checkIsAdmin = async (email: string): Promise<boolean> => {
    if (!email) return false;

    try {
        const adminDocRef = doc(db, 'admins', email.toLowerCase());
        const adminDoc = await getDoc(adminDocRef);

        if (adminDoc.exists()) {
            const data = adminDoc.data() as AdminUser;
            return data.isAdmin === true;
        }

        return false;
    } catch (error) {
        console.error('Error checking admin status:', error);
        return false;
    }
};

/**
 * Get full admin user data
 * @param email User's email address
 * @returns Promise<AdminUser | null>
 */
export const getAdminData = async (email: string): Promise<AdminUser | null> => {
    if (!email) return null;

    try {
        const adminDocRef = doc(db, 'admins', email.toLowerCase());
        const adminDoc = await getDoc(adminDocRef);

        if (adminDoc.exists()) {
            return adminDoc.data() as AdminUser;
        }

        return null;
    } catch (error) {
        console.error('Error getting admin data:', error);
        return null;
    }
};

// Fallback: Local admin email whitelist (use if Firestore is not set up)
export const ADMIN_EMAILS_FALLBACK = [
    'admin@nescotech.com',
    'hamzayasin12443@gmail.com', // Primary admin
    // Add more admin emails here as fallback
];

export const isAdminEmailFallback = (email: string): boolean => {
    return ADMIN_EMAILS_FALLBACK.includes(email.toLowerCase());
};
